<template>
    <div class="flex items-center justify-center">
        <BackButton class="md:mr-8" />
        <BaseButton
            v-if="onlyDesktopVisible"
            key="table-of-contents-button"
            :tooltip="localizations[lang].tooltips.tableOfContents"
            class="block text-theme-icon"
            dusk="buttonTableOfContents"
            type="button"
            icon="baseline-view_list-24px"
            width="24px"
            height="24px"
            :aria-expanded="String(ui.tableOfContents.opened)"
            @click="toggleTableOfContents"
        />

        <BaseButton
            v-if="onlyDesktopVisible && isPdf"
            v-show="ui.thumbnails.enabled"
            key="thumbnails-button"
            :tooltip="localizations[lang].tooltips.openThumbnails"
            class="block text-theme-icon"
            dusk="buttonThumbnails"
            icon="baseline-apps-24px"
            width="24px"
            height="24px"
            :aria-expanded="String(ui.thumbnails.opened)"
            @click="toggleThumbnails"
        />

        <BaseButton
            v-if="onlyDesktopVisible && !isAudiobook"
            key="notebook-button-desktop"
            :tooltip="localizations[lang].notebook"
            class="block text-theme-icon"
            type="button"
            icon-class="text-blue-500"
            :disabled="isOffline"
            data-cy="buttonNotebook"
            icon="outline-description-24px"
            dusk="buttonNotebook"
            width="24px"
            height="24px"
            :aria-expanded="String(ui.notebook.opened)"
            @click="toggleNotebook"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseButton from '../Components/buttons/BaseButton.vue';
import BackButton from '../Components/buttons/BackButton.vue';

export default {
    components: {
        BaseButton,
        BackButton,
    },
    computed: {
        ...mapState(['ui', 'isOffline', 'publication', 'localizations', 'lang']),
        ...mapGetters(['isPdf', 'isAudiobook', 'isEmbeddedMode', 'onlyDesktopVisible', 'onlyMobileVisible']),
    },
    methods: {
        ...mapActions(['toggleTableOfContents', 'toggleThumbnails', 'toggleNotebook']),
    },
};
</script>
